import React from 'react';

import { Helmet } from 'react-helmet';

import { Container } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import GHADiscountSummaryTable from './GHADiscountSummaryTable';

// GHA-442: read-only overview of the currently active GHA discounts per account — live-property
// tier counts, the active discount estate, and the supplier exclusion config.
export default function GHADiscountSummaryContainer() {
  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>GHA Property Discount Summary</title>
      </Helmet>
      <PageSubheader title="GHA Property Discount Summary" />
      <GHADiscountSummaryTable />
    </Container>
  );
}
